
// HELPERS
//---------------------------------------


// Form7 - custom classes
jQuery('.wpcf7-submit').last().addClass('button');


// social share close off-canvas after click
$('.off-canvas .icon-share').on('click', function() {
    $('.off-canvas').foundation('close');
});


// Makes sure last grid item floats left
jQuery('.archive-grid .columns').last().addClass('end');

// page-sub-nav - add active to current page link
jQuery(function($) {
    var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
    $('ul.page-sub-nav li a').each(function() {
        if (this.href === path) {
            $(this).addClass('active');
        }
    });
});


// PAGE FLEXIBLE 
// WRAPS IN A ROW-CONTAINER flexible elements inside .free-column class and outside a ROW  
// jQuery(".free-column .large-12").wrapAll("<div class='row container' />");
// jQuery(".free-column .large-9").wrapAll("<div class='row container' />");
// jQuery(".free-column .large-6").wrapAll("<div class='row container' />");
// jQuery(".free-column .large-4").wrapAll("<div class='row container' />");
// jQuery(".free-column .large-3").wrapAll("<div class='row container' />");

//jQuery(".free-column").wrapAll("<div class='row' />");
//jQuery(".free-column").wrapAll("<div class='row jsadded' />");


// flex featured item, add class to even for zig-zag

$(".editorimage:even .img-col").addClass('large-push-6');
$(".editorimage:even .editor-col").addClass('large-pull-6');

$(".galleryeditor:even .img-col").addClass('large-push-6');
$(".galleryeditor:even .editor-col").addClass('large-pull-6');

// $(".featured_item:even .img-col").addClass('large-push-6');
// $(".featured_item:even .text-col").addClass('large-pull-5');


// cta button on header
$("li.cta").addClass('button large');

// Wrap buttons in hero
jQuery(".wp-block-cover:not(.has-custom-content-position) .button").wrapAll("<div class='button-group align-center jsadded' />");



// footer icon on footer standout buttons
$(".menu.standout li a:not(.external)").each(function() {
    $(this).append('<svg class="icon" viewBox="0 0 60 60"><use xlink:href="#arrow-right"></use></svg>');
});

$(".menu.standout li a.external").each(function() {
    $(this).append('<svg viewBox="0 0 60 60"><use xlink:href="#arrow-external"></use></svg>');
});

